<template>
	<div class="home m-3 has-text-left">
		<section v-for="cat in categories" :key="cat.name" class="mb-5">
			<h2 class="title is-5 mb-3">{{ cat.label }}</h2>
			<div class="is-flex is-flex-wrap-wrap badges">
				<router-link v-for="item in itemsOf(cat)" :key="item.id"
					:to="item.path" class="badge">
					<b-icon :icon="item.icon" size="is-small" class="mr-1" />
					{{ item.label }}
				</router-link>
			</div>
		</section>
		<p class="is-size-7 has-text-grey">
			Sie nutzen die Version {{ applicationVersion }} des Dashboards.
		</p>
	</div>
</template>

<script>
/**
 * The start page: every view as a badge, grouped by the sidebar's
 * categories.
 */

import { version } from "../../../package.json";
import { CATEGORIES, NAV_ITEMS } from "@/lib/config/Navigation";

export default {
	name: "InfoComponent",
	data() {
		return {
			categories: CATEGORIES,
			applicationVersion: version,
		};
	},
	methods: {
		itemsOf(cat) {
			return NAV_ITEMS.filter((item) => item.cat === cat.name);
		},
	},
};
</script>

<style scoped>
.badges {
	gap: 0.5rem;
}

.badge {
	display: inline-flex;
	align-items: center;
	padding: 0.4em 0.9em;
	border-radius: 9999px;
	background-color: whitesmoke;
	border: 1px solid rgb(220, 220, 220);
	color: #363636;
}

.badge:hover {
	background-color: rgb(228, 228, 228);
	color: black;
}
</style>
